// Utilisation de l'API Adresse.data.gouv.fr
const API_URL = 'https://api-adresse.data.gouv.fr/search/';

export const searchAddress = async (query: string) => {
  try {
    const response = await fetch(`${API_URL}?q=${encodeURIComponent(query)}&limit=5`);
    const data = await response.json();
    
    return data.features.map((feature: any) => ({
      address: feature.properties.name,
      postcode: feature.properties.postcode,
      city: feature.properties.city,
      coordinates: feature.geometry.coordinates
    }));
  } catch (error) {
    console.error('Erreur lors de la recherche d\'adresse:', error);
    return [];
  }
};